<style lang="less">
  .brower{
    position: absolute;
    top: 40%;
    font-size: 20px;
    width: 100%;
    text-align: center;
    padding: 0 30px;
  }
</style>
<template>
  <div class="app" id="app">
    <div v-if="browerWin" class="brower">
      {{$t('publesson.tip.browserWin')}}
    </div>
    <component v-else :is="pageName" @routerTo="routerTo" :pageData="pageData"></component>
  </div>
</template>

<script>
  import publessonPage from '@/components/publesson/page';
  import tippage       from '@/components/publesson/tippage.vue';
  export default {
    components:{
      publessonPage:  publessonPage,
      tippage:        tippage
    },
    filters:{
    },
    data(){
      return {
        pageName:'',
        pageData:'',
        browerWin:false,
      }
    },
    methods:{
      routerTo(actionName,pageData, message){
        this.pageName='';
        switch(actionName){
          case 'publessonPage':
            this.pageName = 'publessonPage';
            break;
          case 'jumppage':
            this.pageName = 'jumppage';
            break;
          case 'tippage':
            this.pageName = 'tippage';
            this.pageData = pageData;
            break;
        }
      }
    },
    mounted(){
      this.routerTo('publessonPage');
      this.browerWin = (!window.browserVersion.mobile)&&window.browserVersion.weixin;
    }
  }
</script>